import React from 'react';
import styled from 'styled-components';
import { ChevronDown } from 'react-feather';
import PropTypes from 'prop-types';

import { animation, colors } from '../styles';

const propTypes = {
  children: PropTypes.any
};

const Select = props => {
  const { children, ...all } = props;
  
  return (
    <>
      <SelectWrapper>
        <SelectOptionWrapper {...all}>{children}</SelectOptionWrapper>
        <InputIcon>
          <ChevronDown />
        </InputIcon>
      </SelectWrapper>
    </>
  );
};

const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SelectOptionWrapper = styled.select`
  -webkit-appearance: none;
  border-radius: 0px;
  -webkit-border-radius: 0px;
  width: 100%;
  padding: 10px 16px;
  color: ${colors.midnightBlack};
  background-color: ${colors.pureWhite};
  border: 1px solid ${colors.gray3};
  font-size: 16px;
  transition: border-color ${animation.general.durationAndTiming};
  height: 48px;

  &:hover {
    border-color: #525252;
  }

  &:focus,
  &:active {
    outline: 0;
    border: 1px solid #525252;
  }
`;

const InputIcon = styled.span`
  position: absolute;
  right: 16px;
  bottom: 12px;
  color: ${colors.gray1};
  pointer-events: none; 
`;

Select.propTypes = propTypes;

export { Select };
